export default {
  baseURL: `${import.meta.env.VITE_HSF_API_BASE_URL}/hurricane/`,
  timeout: 290000, // 290 seconds / 4.83 minutes; just before function app cuts off
};
